const t = {
  name: "ArrowBottomSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 16.586L13 4H11L11 16.5857L7.00015 12.5858L5.58594 14L12.0002 20.4142L18.4144 14L17.0002 12.5858L13 16.586Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ArrowBottomSmall
};
